import { Button, Modal } from 'semantic-ui-react';
import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { adminLogout } from '../../actions/auth';

const refreshPage = () => {
    window.location.reload(false);
};

const EnterpriseMismatch = (props) => {
    const { type = 'signedOut' } = props;
    const dispatch = useDispatch();

    const login = useCallback(() => {
        dispatch(adminLogout());
    }, []);

    const options = useMemo(
        () => ({
            signedOut: {
                header: 'Signed Out',
                message: 'You have been signed out of this enterprise. Please refresh your browser to continue',
                button: 'Refresh',
                click: refreshPage
            },
            mismatch: {
                header: 'Incorrect Enterprise',
                message:
                    'The page loaded is for a different enterprise then you are currently logged into. Please log into to the correct enterprise',
                button: 'Enterprise Selection',
                click: login
            }
        }),
        []
    );

    const { header, message, button, click } = options[type];

    return (
        <Modal size="mini" open>
            <Modal.Header>{header}</Modal.Header>
            <Modal.Content>{message}</Modal.Content>
            <Modal.Actions>
                <Button onClick={click}>{button}</Button>
            </Modal.Actions>
        </Modal>
    );
};

export default EnterpriseMismatch;
